// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Stage chip — the alarm's response-lifecycle label (Unacknowledged, In
// Progress, Work Order, …). Stage → label comes from theme/alarmStage.ts;
// stage → color is a class from the sibling CSS module.

import React from 'react';
import type { Alarm, AlarmStage } from '../../../types/alarm';
import { alarmStage } from '../../../theme/alarmStage';
import { useRaisedWorkOrder } from '../../../hooks/useAlarmWorkOrderLinks';
import styles from './StageChip.module.css';

const STAGE_CLASS: Record<AlarmStage, string> = {
  unacknowledged: styles.unacknowledged,
  unvalidated: styles.unvalidated,
  'in-progress': styles['in-progress'],
  'work-order': styles['work-order'],
  cleared: styles.cleared,
  closed: styles.closed,
};

export function StageChip({ alarm }: { alarm: Alarm }) {
  // The link a work order created in this browser left behind counts too: the
  // BFF doesn't carry it yet, so without it an acknowledged alarm with an open
  // order would read as "In Progress" (or "Closed · no WO" once cleared).
  const raised = useRaisedWorkOrder(alarm);
  const { stage, label } = alarmStage(
    raised && !alarm.workOrder
      ? { ...alarm, workOrder: { id: raised.id, reference: raised.reference } }
      : alarm
  );
  return (
    <span className={`hs-stage-chip ${STAGE_CLASS[stage]}`} data-stage={stage}>
      {label}
    </span>
  );
}

export default StageChip;
